<h4 class="page-title">
  <button class="btn btn-outline-blue btn-rounded" (click)="voltar()" *ngIf="!widget" style="margin-right: 5px;">
    <i class="fa fa-arrow-left ct-point" ></i>
  </button>
  <i class="fe-user "></i> Contato</h4>

<section class="demonstracao-mia card" *ngIf="demonstracaoVisivel" aria-labelledby="titulo-demonstracao-mia"
  [attr.aria-busy]="carregandoDemonstracao || salvandoDemonstracao">
  <div class="card-body">
    <div class="demonstracao-mia__cabecalho">
      <div>
        <h5 id="titulo-demonstracao-mia"><i class="fe-message-circle" aria-hidden="true"></i> Demonstração da MIA</h5>
        <p class="text-muted mb-0">Escolha a empresa que este contato vai testar no número de exemplo.</p>
      </div>
      <span class="badge badge-success" *ngIf="empresaDemonstracaoSalva">Associado</span>
    </div>
    <p *ngIf="carregandoDemonstracao" class="text-muted mt-3 mb-0" role="status">Carregando configuração…</p>
    <p *ngIf="!carregandoDemonstracao && !demonstracaoHabilitada && !erroDemonstracao" class="text-muted mt-3 mb-0">
      Disponível apenas na empresa dona de um número marcado como "Número de exemplo da Mia" (superadmin, Mia Gestor › Número da Mia).
    </p>
    <div *ngIf="demonstracaoHabilitada && !carregandoDemonstracao && !erroCarregamentoDemonstracao" class="demonstracao-mia__formulario">
      <div class="demonstracao-mia__campo">
        <label for="empresa-demonstracao-mia">Empresa para demonstração</label>
        <kendo-combobox id="empresa-demonstracao-mia" name="empresaDemonstracaoMia"
          [(ngModel)]="empresaDemonstracao" [data]="empresasDemonstracao" textField="nome" valueField="id"
          [filterable]="true" [allowCustom]="false" [clearButton]="true" [loading]="buscandoEmpresasDemonstracao"
          [disabled]="salvandoDemonstracao" (filterChange)="busqueEmpresasDemonstracao($event)"
          (valueChange)="alterouEmpresaDemonstracao()" placeholder="Busque uma empresa"
          aria-describedby="ajuda-demonstracao-mia">
          <ng-template kendoComboBoxNoDataTemplate>Nenhuma empresa encontrada.</ng-template>
        </kendo-combobox>
        <small id="ajuda-demonstracao-mia" class="text-muted d-block mt-2">
          Trocar a empresa inicia um novo teste. Limpe a seleção para voltar ao atendimento padrão.
          Pedidos da demonstração não geram cobrança nem entram no PDV.
        </small>
      </div>
      <button type="button" class="btn btn-blue demonstracao-mia__salvar" (click)="salveDemonstracao()"
        [disabled]="salvandoDemonstracao || !demonstracaoAlterada()">
        {{ salvandoDemonstracao ? 'Salvando…' : 'Salvar associação' }}
      </button>
    </div>
    <div *ngIf="erroDemonstracao" class="alert alert-danger mt-3 mb-0" role="alert">
      {{ erroDemonstracao }}
      <button type="button" class="btn btn-link p-0 ml-2" (click)="carregueDemonstracao()"
        *ngIf="erroCarregamentoDemonstracao" [disabled]="carregandoDemonstracao">Tentar novamente</button>
    </div>
    <p *ngIf="sucessoDemonstracao" class="text-success mt-3 mb-0" role="status">{{ sucessoDemonstracao }}</p>
  </div>
</section>

<div class="row"  [hidden]="!contato.id">
  <div class="col-12">
    <div class="card contato">
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-4">
            <card-contato [contato]="contato" [exibirUltimaVisita]="false" [exibirEmail]="true" [exibirEndereco]="true">

            </card-contato>
            <button class="btn btn-rounded btn-outline-danger waves-effect "  (click)="remover(contato)" *ngIf="false"> //TODO: Refazer remover contato
              <div class="icone "> <i class="fas fa-trash" style="font-size: 24px; line-height: 32px" ></i> </div>
            </button>

            <button class="btn btn-rounded btn-blue waves-effect waves-light editar" (click)="editarContato(contato)"
            style="    float: right; top: 0;   position: absolute;  right: 10px;">
              <i class="fe-edit"  > </i>
            </button>

            <button type="button" class="btn btn-outline-danger btn-sm mt-2" *ngIf="podeMesclarContatos()"
                    (click)="abraModalMesclarContatos()">Mesclar contatos</button>


            <div class="form-group">
              <div class="input-group" >
                <kendo-autocomplete [loading]="buscandoTag"   style="width: 240px" [data]="tags"   [highlightFirst]="true"
                                    #tagList  name="tagList"       [valueField]="'nome'"
                                    [kendoDropDownFilter]="{ operator: 'contains' }"
                                    [filterable]="true"
                                    placeholder="Tag: crie ou adicione uma tag"
                                    (valueChange)="alterouTag($event)"
                >
                </kendo-autocomplete>

                <div class="d-inline-block ml-1">
                  <button class="btn btn-success " *ngIf="novaTag" (click)="salveTag()">
                    <i class="k-icon k-i-save " *ngIf="!salvandoTag"> </i>
                    <i class="k-icon k-i-loading" *ngIf="salvandoTag"></i>
                  </button>

                  <button class="btn btn-blue  " *ngIf="!novaTag" (click)="adicioneTagSelecionada()" [disabled]="!tagSelecionada?.id">
                    <i class="k-icon k-i-plus " *ngIf="!salvandoTag"> </i>
                    <i class="k-icon k-i-loading" *ngIf="salvandoTag"></i>
                  </button>
                </div>
              </div>
            </div>

          </div>

          <div class="col-12 col-md-8 plano-info">
             <div class="card-box plano">
              <div class="float-left">
                <label class="mb-1">Cartão Fidelidade:</label>
                <kendo-combobox id="cartao" name="cartao" [(ngModel)]="filtro.cartao" [data]="cartoes" [filterable]="true"
                                [allowCustom]="false" placeholder="Selecione um Cartão" class="form-control" [clearButton]="false"
                                [textField]="'descricao'"
                                [kendoDropDownFilter]="filterSettings" (selectionChange)="alterouCartao($event)">
                </kendo-combobox>

                <h5 class="text-danger ml-1" *ngIf="planoDesativado()">
                  Plano está desativado</h5>
              </div>
               <div class="float-right text-center d-none d-sm-block">
                 <span class="text-black"  > <i class="fa fa-calendar"></i> {{ contato?.ultimaVisita | date: 'dd/MM/yyyy HH:mm'}}</span><br>
                 <label class="text-muted font-13 ">Última visita</label>
               </div>

             </div>
              <div class="card-box pontos" [hidden]="!porPontos()"  >
                <label> Pontos:  </label>
                <span class="text-success  ml-2">
                    {{filtro?.cartao?.pontos | number}}
                 </span>
              </div>

              <div class="card-box pontos" [hidden]="!porReais()"  >
                <label> Saldo:  </label> <span class="text-success  ml-2">{{filtro?.cartao?.pontos | currency: "BRL"}}</span>
              </div>

              <div class="card-box por-selo" [hidden]="!porSelos()" >
                  <label class="float-left"  > Selos:  </label>
                  <span class="lista-selos">
                  <app-selos-cartao #selosCartao></app-selos-cartao>
              </span>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 mb-3">
    <acoes-modulos #acoesModulo [contato]="contato"  [cartao]="filtro?.cartao" (salvouContato)="eventoSalvouContato(contato)" ></acoes-modulos>
  </div>

  <div class="col-12 mb-0" *ngIf="contato !== null">
    <div class="alert mt-2 mb-2" role="alert" *ngIf="respServerAlterouAtivarDesativar"
         [class.alert-danger]="!respServerAlterouAtivarDesativar.sucesso"
         [class.alert-success]="respServerAlterouAtivarDesativar.sucesso">
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <i class="fas fa-exclamation-triangle" *ngIf="!respServerAlterouAtivarDesativar.sucesso"></i>
      <i class="mdi mdi-check-all mr-2" *ngIf="respServerAlterouAtivarDesativar.sucesso"></i>
      {{respServerAlterouAtivarDesativar.mensagem}}
    </div>
    <div class="form-group">
      <label>Desativar mensagens de marketing</label>
      <div class="mt-0 mb-1 font-24 valor">
        <kendo-switch name="exibirCardapio" [(ngModel)]="contato.desativarMensagensDeMarketing"
                      (ngModelChange)="alterouDesativarEnvioMsgMarketing($event)"
                      [onLabel]="'Sim'"
                      [offLabel]="'Não'"></kendo-switch>
      </div>
    </div>
  </div>

  <div class="col-12">
    <app-perfil-cliente [contato]="contato"></app-perfil-cliente>
  </div>

  <div class="col-12">
    <info-pedidos [contato]="contato"  [empresa]="empresa" ></info-pedidos>
  </div>

  <div class="col-12">
    <kendo-tabstrip class="nav-bordered historico-cliente-tabs" (tabSelect)="selecionouAbaHistorico($event)">
      <kendo-tabstrip-tab [title]="'Financeiro'" [selected]="true" *ngIf="exibirFinanceiro">
        <ng-template kendoTabContent>
          <div class="historico-financeiro">
            <div class="historico-financeiro-header">
              <div>
                <h3>Financeiro</h3>
                <span>Créditos da conta e acertos do fiado do cliente</span>
              </div>

              <div class="historico-financeiro-acoes">
                <div class="financeiro-acao-card financeiro-acao-fiado">
                  <a class="financeiro-acao-link"
                     [routerLink]="['/admin/fiados']"
                     [queryParams]="{idContato: contato?.id}">
                    <small>Saldo devedor fiado</small>
                    <strong>{{saldoDevedorFiado || 0 | currency:'BRL'}}</strong>
                  </a>

                  <div class="financeiro-fiado-botoes">
                    <button class="btn-fazer-acerto" type="button"
                            (click)="abraModalAcertoFinanceiro()"
                            [disabled]="carregandoLancamentosFiado || !(saldoDevedorFiado > 0)">
                      <span class="btn-icone"><i class="fa fa-check"></i></span>
                      Fazer Acerto
                    </button>

                    <a class="btn-ver-fiados"
                       [routerLink]="['/admin/fiados']"
                       [queryParams]="{idContato: contato?.id}">
                      <span class="btn-icone"><i class="fa fa-eye"></i></span>
                      Ver fiados
                    </a>
                  </div>
                </div>

                <div class="financeiro-acao-card financeiro-acao-credito" *ngIf="contaFinanceira">
                  <div class="financeiro-acao-resumo">
                    <small>Saldo atual</small>
                    <strong>{{contaFinanceira?.saldo || 0 | currency:'BRL'}}</strong>
                  </div>

                  <button class="btn-adicionar-credito" type="button" (click)="abraModalCreditoFinanceiro()">
                    <span class="btn-icone"><i class="fa fa-plus"></i></span>
                    Adicionar crédito
                  </button>
                </div>
              </div>
            </div>

            <div class="alert alert-danger" *ngIf="erroLancamentosFiado">
              {{erroLancamentosFiado}}
            </div>

            <kendo-tabstrip class="financeiro-subtabs" (tabSelect)="selecionouAbaFinanceiro($event)">
              <kendo-tabstrip-tab [title]="'Histórico financeiro'" [selected]="true">
                <ng-template kendoTabContent>
                  <div class="financeiro-subtab-conteudo">
                    <div class="alert alert-danger" *ngIf="erroHistoricoFinanceiro">
                      {{erroHistoricoFinanceiro}}
                    </div>

                    <div class="estado-financeiro" *ngIf="carregandoHistoricoFinanceiro">
                      Carregando histórico financeiro...
                    </div>

                    <div class="estado-financeiro" *ngIf="!carregandoHistoricoFinanceiro && !erroHistoricoFinanceiro && !movimentosFinanceiros.length">
                      Nenhum movimento financeiro encontrado.
                    </div>

                    <div class="table-responsive" *ngIf="!carregandoHistoricoFinanceiro && movimentosFinanceiros.length">
                      <table class="table table-sm historico-financeiro-table">
                        <thead>
                        <tr>
                          <th>Data</th>
                          <th>Tipo</th>
                          <th>Origem</th>
                          <th>Operador</th>
                          <th>Forma</th>
                          <th class="text-right">Valor</th>
                          <th class="text-right">Saldo após</th>
                          <th>Observação</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let movimento of movimentosFinanceiros">
                          <td>{{movimento?.criadoEm | date:'dd/MM/yy HH:mm'}}</td>
                          <td>
                            <span class="movimento-tipo" [class.credito]="movimentoEhCredito(movimento)" [class.debito]="!movimentoEhCredito(movimento)">
                              {{obtenhaLabelTipoMovimento(movimento?.tipo)}}
                            </span>
                          </td>
                          <td>{{obtenhaLabelOrigemMovimento(movimento?.origem)}}</td>
                          <td>{{obtenhaNomeOperadorMovimento(movimento)}}</td>
                          <td>{{movimento?.formaDePagamento?.descricao || movimento?.formaDePagamento?.nome || '-'}}</td>
                          <td class="text-right valor-movimento" [ngClass]="obtenhaClasseValorMovimento(movimento)">
                            {{obtenhaValorMovimentoSinalizado(movimento)}}
                          </td>
                          <td class="text-right">{{movimento?.saldoResultante || 0 | currency:'BRL'}}</td>
                          <td>{{movimento?.observacao || '-'}}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </ng-template>
              </kendo-tabstrip-tab>

              <kendo-tabstrip-tab [title]="'Histórico Acerto'">
                <ng-template kendoTabContent>
                  <div class="financeiro-subtab-conteudo">
                    <div class="alert alert-danger" *ngIf="erroHistoricoAcertos">
                      {{erroHistoricoAcertos}}
                    </div>

                    <div class="estado-financeiro" *ngIf="carregandoHistoricoAcertos">
                      Carregando histórico de acertos...
                    </div>

                    <div class="estado-financeiro" *ngIf="!carregandoHistoricoAcertos && !erroHistoricoAcertos && !acertosFiado.length">
                      Nenhum acerto de fiado encontrado.
                    </div>

                    <div class="table-responsive" *ngIf="!carregandoHistoricoAcertos && acertosFiado.length">
                      <table class="table table-sm historico-financeiro-table">
                        <thead>
                        <tr>
                          <th>Data</th>
                          <th>Forma</th>
                          <th>Operador</th>
                          <th class="text-right">Valor</th>
                          <th>Observação</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let acerto of acertosFiado">
                          <td>{{acerto?.dataPagamento | date:'dd/MM/yy HH:mm'}}</td>
                          <td>{{acerto?.formaDePagamento?.descricao || acerto?.formaDePagamento?.nome || '-'}}</td>
                          <td>{{obtenhaNomeOperadorAcerto(acerto)}}</td>
                          <td class="text-right valor-acerto">{{acerto?.valorTotal || 0 | currency:'BRL'}}</td>
                          <td>{{acerto?.observacao || '-'}}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </ng-template>
              </kendo-tabstrip-tab>
            </kendo-tabstrip>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab [title]="'Histórico'" [selected]="!exibirFinanceiro">
        <ng-template kendoTabContent>
          <app-historico-modulos [contato]="contato" [empresa]="empresa" (onEstornouPontos)="carregueContato()" ></app-historico-modulos>
        </ng-template>
      </kendo-tabstrip-tab>


    </kendo-tabstrip>
  </div>


  <app-dialog-remover-contato [contatoSelecionado]="contato" [tela]="this" [abraDialogo]="abraDialogo"></app-dialog-remover-contato>
</div>
<!--
<div class="row"  [hidden]="contato != null">
  <div class="col">
    <div style="width: 100%;">
      <div class="contato">
        <label class="mb-1">{{nomeContato}}</label>
        <p>
          <span class="text-muted">
            <i class="fab fa-whatsapp" style="color: #82c91e;font-size: 14px;"></i> {{telefone | mask: '(99) 9-9999-9999' }}</span>
        </p>
      </div>

      <h5 class="mt-2">Você ainda fidelizou esse cliente</h5>
    </div>

    <div clas="mt=2">
    <button _ngcontent-evq-c8="" class="btn btn-blue   btn-lg  waves-effect waves-light float-left " type="button"
     (click)="abraTelaNovoContato()">
      <i _ngcontent-evq-c8="" class="fe-user-plus"></i> Fidelizar Agora </button>
    </div>
  </div>
</div>
-->
